import React from 'react'
import "./footer.css";

function Footer() {
    return (
        <div className="footer">
           <p className="footer-text">© 2021 Made by Sarah</p> 
        </div>
    )
}

export default Footer
